import { gql } from "@apollo/client";

export const GET_ALL_TYPE_EVALUATION = gql`
query GET_ALL_TYPE_EVALUATION($idCompany: ID!) {
      GET_ALL_TYPE_EVALUATION(idCompany: $idCompany) {
        id
        name
    }
  }
`;

export const GET_ALL_PERFORMANCES_EVALUATION = gql`
query GET_ALL_PERFORMANCES_EVALUATION {
  GET_ALL_PERFORMANCES_EVALUATION{
    id
    namePerformance
    tipoEvaluacion
    idTypeEvaluation
    pctAutoevaluacion
    pctLider
    pctColegas
    pctSubordinados
    pctClientes
    active
    step  
    inptDateClose
    modelEvaluation
    DateInit
    DateEnd
    description
    personasEvaluar
    countColEval
    progresoReal    
    areas {
      area
      id
    }
    }
  }
`;

export const UPDATE_ACTIVE_PERFORMANCE_EVALUATION = gql`
mutation UPDATE_ACTIVE_PERFORMANCE_EVALUATION($id:ID!) {
  UPDATE_ACTIVE_PERFORMANCE_EVALUATION(id: $id)
}
`;

export const CREATE_PERFORMANCE_EVALUATION = gql`
  mutation CREATE_PERFORMANCE_EVALUATION($input: performanceEvaluation_Input) {
    CREATE_PERFORMANCE_EVALUATION(input: $input)
   }
`;

export const DELETE_PERFORMANCE_EVALUATION = gql`
mutation DELETE_PERFORMANCE_EVALUATION($id: ID!) {
  DELETE_PERFORMANCE_EVALUATION(id: $id)
}
`;

export const GET_PEFORMANCE_EVALUATION_COLLBORATORS = gql`
query GET_PEFORMANCE_EVALUATION_COLLBORATORS($idPerEval: ID!,$idCompany:ID!) {
  GET_PEFORMANCE_EVALUATION_COLLBORATORS(idPerEval: $idPerEval,idCompany:$idCompany){
    id
    namePerformance
    tipoEvaluacion
    pctAutoevaluacion
    pctLider
    pctColegas
    pctSubordinados
    pctClientes
    active
    step
    collaborators {
      id
      email
      emailSend
      bussinesName
      ImagenUsuario
      abrvName
      sede
      areaProject
      idLider
      idColega
      idSubornidado
      idCliente
      lider {
        id
        name
        email
        typeEvaluator
      }     
     colega {
        id
        name
        email
        typeEvaluator
      } 
      subornidado {
        id
        name
        email
        typeEvaluator
      }
      cliente {
        id
        name
        email
        typeEvaluator
      }
    
    }
  }
}
`;

export const GET_COLLBORATORS_NOT_IN_PEREVAL = gql`
query GET_COLLBORATORS_NOT_IN_PEREVAL($idPerEval: ID!,$idCompany:ID!) {
  GET_COLLBORATORS_NOT_IN_PEREVAL(idPerEval: $idPerEval,idCompany:$idCompany) {
        id
        bussinesName
    }
  }
`;

export const CREATE_ADD_COL_PER_EVAL = gql`
  mutation CREATE_ADD_COL_PER_EVAL($input: addColPerEval_Input) {
    CREATE_ADD_COL_PER_EVAL(input: $input)
   }
`;

export const CREATE_ADD_EVAL_EXT_PER_EVAL = gql`
  mutation CREATE_ADD_EVAL_EXT_PER_EVAL($input: newEval_Ext_Input) {
    CREATE_ADD_EVAL_EXT_PER_EVAL(input: $input)
   }
`;


export const DELETE_EXT_PER_EVAL = gql`
mutation DELETE_EXT_PER_EVAL($input: info_EVal_Ext!) {
  DELETE_EXT_PER_EVAL(input: $input)
}
`;


export const UPDATE_ADD_EVAL_EXT_PER_EVAL = gql`
mutation UPDATE_ADD_EVAL_EXT_PER_EVAL($input: updateEval_Ext_Input!) {
  UPDATE_ADD_EVAL_EXT_PER_EVAL(input: $input)
}
`;

export const CREATE_COL_EMAIL_PER_EVAL = gql`
  mutation CREATE_COL_EMAIL_PER_EVAL($input: [addColEmailPerEval_Input]) {
    CREATE_COL_EMAIL_PER_EVAL(input: $input)
   }
`;

export const UPDATE_STEP_PERFORMANCE_EVALUATION = gql`
mutation UPDATE_STEP_PERFORMANCE_EVALUATION($id:ID!) {
  UPDATE_STEP_PERFORMANCE_EVALUATION(id: $id)
}
`;

export const UPDATE_FINALIZE_PERFORMNACE_EVALUATION = gql`
mutation UPDATE_FINALIZE_PERFORMANCE_EVALUATION($updateFinalizePerformanceEvaluationId: ID!) {
  UPDATE_FINALIZE_PERFORMANCE_EVALUATION(id: $updateFinalizePerformanceEvaluationId)
}
`;

//Obtiene los años de las evaluaciones terminadas
export const GET_PERFORMANCE_EVALUATIONS_YEARS = gql`
  query GET_PERFORMANCE_EVALUATIONS_YEARS {
    GET_PERFORMANCE_EVALUATIONS_YEARS {
      YEAR
    }
  }
`;

export const GET_PERFORMANCE_EVALUATIONS_HISTORICS = gql`
  query GET_PERFORMANCE_EVALUATIONS_HISTORICS($year: Int) {
    GET_PERFORMANCE_EVALUATIONS_HISTORICS(year: $year) {
      id
      namePerformance
      startPerformance
      endPerformance
      dateClosePerformance
      description
      personasEvaluar
    }
  }
`;

